import {Component, OnInit, HostListener, ViewContainerRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddContactComponent } from '../../shared/add-contact-modal/add-contact.component';
import { CreateGroupComponent } from './create-group-modal/create-group.component';
import { globalSettings } from '../../shared/config';
import { DataService } from '../../data.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AuthService } from '../../auth/auth.service';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/toPromise';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'app-companies',
    templateUrl: './companies.component.html',
    styleUrls: ['./companies.component.scss']
})

export class CompaniesComponent implements OnInit {
    public groupActive: Boolean = false;
    public overlay: Boolean = false;
    public isLoading: Boolean = true;
    public gettingOlderCompanies: Boolean = false;
    public groups: Array<{}>;
    public companies = [];
    public companiesTotal: number;
    public formSearch;
    public searchOpen: Boolean = false;
    // for infinity scroll begin
    public searchState = 1;
    private skipCompanies = 0;
    private limitCompanies = 12;
    private limitNewCompanies = 5;
    private allCompanies = false;
    // for infinity scroll end;

    constructor(private modalService: NgbModal,
                private router: Router,
                private route: ActivatedRoute,
                private dataService: DataService,
                private authService: AuthService,
                private fb: FormBuilder,
                public toastr: ToastsManager,
                vcr: ViewContainerRef) {
        this.groups = [
            {
                id: 0,
                name: 'All companies',
                notify: 0,
            },
        ];
        this.toastr.setRootViewContainerRef(vcr);
    }

    ngOnInit() {
        if (!this.authService.isLoggedUser()) {
            this.router.navigate(['/login']);
        }
        this.buildForm();
        this.dataService.getCompanies(this.limitCompanies, this.skipCompanies, this.searchState, this.formSearch.get('search').value)
            .toPromise()
            .then((companies) => {
                this.isLoading = false;
                this.companiesTotal = companies.json().meta.total;
                this.companies = companies.json().data;
                this.skipCompanies += this.limitCompanies
            });
    }

    public buildForm() {
        this.formSearch = this.fb.group({
            search: ['']
        });
    }

    public onSearchCompany(form) {
        this.allCompanies = false;
        this.skipCompanies = 0;
        this.dataService.getCompanies(this.limitCompanies, this.skipCompanies, this.searchState, this.formSearch.get('search').value)
            .toPromise()
            .then((companies) => {
                this.isLoading = false;
                this.companiesTotal = companies.json().meta.total;
                this.companies = companies.json().data;
                this.skipCompanies += this.limitCompanies
            }, (err) => {
                this.router.navigate(['/login']);
            })
            .catch((err) => {console.log(2); this.router.navigate(['/login'])});
    }

    public sendByEnter(event, form) {
        if (event.keyCode === 13 && form.valid) {
            this.onSearchCompany(form);
        }
    }

    public toggleSearchFrom() {
        this.searchOpen = !this.searchOpen;
        this.formSearch.get('search').setValue('');
        if (!this.searchOpen) {
              this.skipCompanies = 0;
              this.allCompanies = false;
              this.dataService.getCompanies(this.limitCompanies, this.skipCompanies, this.searchState, this.formSearch.get('search').value)
            .toPromise()
            .then((companies) => {
                this.isLoading = false;
                this.companies = companies.json().data;
                this.companiesTotal = companies.json().meta.total;
                this.skipCompanies += this.limitCompanies
            });

        }
    }

    public resetForm() {
        this.formSearch.reset();
         this.formSearch.get('search').setValue('');
        if (this.searchOpen) {
              this.skipCompanies = 0;
              this.allCompanies = false;
              this.dataService.getCompanies(this.limitCompanies, this.skipCompanies, this.searchState, this.formSearch.get('search').value)
            .toPromise()
            .then((companies) => {
                this.isLoading = false;
                this.companiesTotal = companies.json().meta.total;
                this.companies = companies.json().data;
                this.skipCompanies += this.limitCompanies
            });

        }
    }

    public open() {
        const modalRef = this.modalService.open(AddContactComponent, {windowClass: 'add-contact-modal'});
        modalRef.result.then((res) => {
            if (res.type === 'error') {
                this.toastr.error(`This company's email address is already registered`, 'Error!')
            } else if (res.type === 'success') {
                this.toastr.success('Company "' + res.data.name + '" was created!', 'Success!');
                this.companiesTotal++;
                this.companies.unshift(res.data);
            }
        });
    }

    public changeGroups() {
        this.groupActive = !this.groupActive;
    }

    @HostListener('scroll', ['$event'])
    public onScroll(event): void {
            const scrollHeight = event.target.scrollHeight;
            const clientHeight = event.srcElement.clientHeight;
            const scrolled = Math.ceil( event.target.scrollTop );
            if (scrolled && scrollHeight - clientHeight <= scrolled && !this.allCompanies) {
                this.getOlderCompanies();
            }
    }

    public getOlderCompanies() {
        if (this.gettingOlderCompanies) {
        this.dataService.getCompanies(this.limitNewCompanies, this.skipCompanies, this.searchState, '')
            .toPromise()
            .then((companies) => {
                const resp = companies.json().data;
                this.allCompanies = resp.length === 0 ? true : false;
                this.gettingOlderCompanies = false;
                this.companies.push(...companies.json().data);
                this.skipCompanies += this.limitNewCompanies;
            });
        }
            this.gettingOlderCompanies = true;

    }

    public sortCompanies() {
        if (this.searchState % 3 !== 0) {
            this.searchState = this.searchState + 1;
        } else {
            this.searchState = 1;
        }
        this.skipCompanies = 0;
        this.allCompanies = false;
        this.dataService.getCompanies(this.limitCompanies, this.skipCompanies, this.searchState, this.formSearch.get('search').value)
            .toPromise()
            .then((companies) => {
                this.isLoading = false;
                this.companiesTotal = companies.json().meta.total;
                this.companies = companies.json().data;
                this.skipCompanies += this.limitCompanies
            });
    }


    public onSelectGroups() {
        this.groupActive = !this.groupActive;
    }
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/pages/companies/companies.component.ts